import React from 'react';
import styled from 'styled-components';
import {
  AiOutlineFile,
  AiOutlineFileExcel,
  AiOutlineFilePdf,
  AiOutlineFileWord,
  AiOutlineFileZip,
} from 'react-icons/ai';
import { FaTrash } from 'react-icons/fa';
import { VscJson } from 'react-icons/vsc';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  hideTrash?: boolean;
  type?: string;
}

const Icon = styled.div`
  border-radius: 10px;
  background: none;
  color: white;
  margin-right: 0.5rem;

  display: flex;
  align-items: center;
`;

const Content = styled.div`
  color: white;
  font-family: Lato;
  flex-grow: 1;
`;

const Trash = styled.button`
  border: none;
  border-radius: 10px;

  background: none;
  color: grey;

  cursor: pointer;
  margin-left: 0.5rem;

  padding: 0;

  display: flex;
  align-items: center;
  justify-content: end;

  height: 32px;
  width: 32px;

  &:hover {
    color: lightgrey;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
`;

const iconType: Map<string, JSX.Element> = new Map();

iconType.set('doc', <AiOutlineFileWord />);
iconType.set('docx', <AiOutlineFileWord />);
iconType.set('pdf', <AiOutlineFilePdf />);
iconType.set('xlsx', <AiOutlineFileExcel />);
iconType.set('json', <VscJson />);
iconType.set('zip', <AiOutlineFileZip />);
iconType.set('rar', <AiOutlineFileZip />);

export const UploadLi: React.FunctionComponent<Props> = ({
  children,
  hideTrash,
  onClick,
  type,
}: Props) => {
  const parsedType = iconType.get(type || '');
  return (
    <Wrapper>
      <Icon>{parsedType || <AiOutlineFile />}</Icon>
      <Content>{children}</Content>
      {hideTrash ? undefined : (
        <Trash onClick={onClick}>
          <FaTrash />
        </Trash>
      )}
    </Wrapper>
  );
};
